/* Night Flow funnels (theme version): campaign attribution on every product link.
   Keeps the allowlisted campaign parameters of the landing URL and adds nf_funnel=presell-v1|quiz-v1.
   Nothing else travels: no answers, no symptoms. */
(function (root) {
  'use strict';
  var KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid', 'campaign_id', 'adset_id', 'ad_id'];
  function productUrl(search, funnel, base) {
    var incoming = new URLSearchParams(search || '');
    var origin = root.location ? root.location.href : 'https://slimava.com/';
    var url = new URL(base || '/products/gut-relief', origin);
    for (var i = 0; i < KEYS.length; i++) { var v = incoming.get(KEYS[i]); if (v && v.length <= 512) url.searchParams.set(KEYS[i], v); }
    url.searchParams.set('nf_funnel', funnel === 'quiz' ? 'quiz-v1' : 'presell-v1');
    return url.href;
  }
  function route() { return root.document.body.classList.contains('quiz-body') ? 'quiz' : 'presell'; }
  function decorate(scope) {
    var links = (scope || root.document).querySelectorAll('[data-product-link]');
    for (var i = 0; i < links.length; i++) {
      var a = links[i];
      if (!a.getAttribute('data-nf-base')) a.setAttribute('data-nf-base', a.getAttribute('href') || '/products/gut-relief');
      a.href = productUrl(root.location.search, route(), a.getAttribute('data-nf-base'));
    }
  }
  var api = { productUrl: productUrl, decorate: decorate };
  if (typeof module !== 'undefined' && module.exports) module.exports = api;
  if (!root.document) return;
  root.NF_SHARED = api;
  decorate();
  root.document.addEventListener('click', function (event) {
    if (event.target.closest && event.target.closest('[data-product-link]')) root.document.dispatchEvent(new CustomEvent('nightflow:funnel', { detail: { funnel: route(), action: 'product_click' } }));
  });
  if (root.Shopify && root.Shopify.designMode) root.document.addEventListener('shopify:section:load', function (e) { decorate(e.target); });
})(typeof window !== 'undefined' ? window : globalThis);
